import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as leaveWarnReducer } from 'components/LeaveWarn';
import tube from '../screens/Tube/reducers/';
import application from './applicationReducer';
import user from './userReducer';
import message from './messageReducer';
import login from '../screens/Login/reducers/';
export default combineReducers({
  tube,
  application,
  user,
  message,
  login,
});

export function createRootReducer(moduleName, moduleReducer) {
  const appReducer = combineReducers({
    application,
    user,
    message,
    [moduleName]: moduleReducer,
    login,
  });

  return combineReducers({
    app: appReducer,
    form: formReducer,
    leaveWarn: leaveWarnReducer,
  });
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/reducers/index.js
 **/